import { ROLES } from '@app/navigation/types';
import { OutletUpdateCounts, OutletUpdateDecision } from '@app/api/models/acb';
import { RequestPayload } from '@app/api/types';

export const APPROVAL_STATUS = 4;
export const UPDATE_REQUESTS_CHANGED = 'outlet-update-requests-changed';
export const canAccessApprovalQueue = (role: string | undefined) =>
  role === ROLES.CHIEF || role === ROLES.ADMIN;

export const canApproveRequest = (role: string | undefined, statusId: number | string) =>
  canAccessApprovalQueue(role) && Number(statusId) === APPROVAL_STATUS;

export const requestQueueFilter = (role: string | undefined, filter: RequestPayload['filter'], approvalQueue: boolean) => {
  if (approvalQueue) { return { ...filter, status_id: [APPROVAL_STATUS], process_type: ['others'] }; }
  if (role === ROLES.CHIEF || role === ROLES.TRADE_MARKETING) {
    const selected = filter.status_id as number[] | undefined;
    const statuses = (selected?.length ? selected : [1, 2, 3]).filter((id) => Number(id) !== APPROVAL_STATUS);
    // Пустой массив сервер трактует как отсутствие фильтра.
    return { ...filter, status_id: statuses.length ? statuses : [-1] };
  }
  return filter;
};

export const updateCount = (data: OutletUpdateCounts, role: string | undefined, approvalQueue = false) => {
  if (approvalQueue) { return canAccessApprovalQueue(role) ? data.approval ?? 0 : 0; }
  if (role === ROLES.TRADE_MARKETING) { return data.channels ?? 0; }
  if (role === ROLES.ADMIN) { return (data.channels ?? 0) + (data.others ?? 0); }
  return data.others ?? 0;
};

// История может содержать создание и другие переходы, а не только решения.
export const decisionLabel = (item: OutletUpdateDecision, previous?: OutletUpdateDecision) => {
  if (previous?.status.id === APPROVAL_STATUS && item.status.id === 1) { return 'Согласована'; }
  if (previous?.status.id === APPROVAL_STATUS && item.status.id === 2) { return 'Отклонена'; }
  return item.status.id === APPROVAL_STATUS ? 'Ожидает согласования' : item.status.name;
};
